export default {
	next: '下一頁',
	previous: '上一頁'
};
